import React from "react";
import { components } from "react-select";
import { formatDateDisplay } from "../../../../utils/common";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { TOOLTIP_DELAY } from "../../../common/Constants";

// Table Cell Formatters

export function StatusTmpl({ cell }: any) {
  const status = cell.getValue() || "";
  const statusLower = status.toLowerCase();

  let colorClass = "";

  if (statusLower.includes("open")) {
    colorClass = "open";
  } else if (statusLower.includes("in_progress")) {
    colorClass = "in_progress";
  } else if (statusLower.includes("on_hold")) {
    colorClass = "on_hold";
  } else if (statusLower.includes("resolved")) {
    colorClass = "closed";
  }

  return (
    <span className={`text-capitalize color-class fw-bold ${colorClass}`}>
      {status.replace(/_/g, " ")}
    </span>
  );
}

export function TagsTmpl({ cell }: any) {
  const tags = cell.getValue() || "";
  const tagsLower = tags.toLowerCase();
  const row = cell.getData();

  // Get the relevant date field based on type (litigation or notice)
  // Litigations have court_name, notices don't
  const isLitigation = row.court_name !== undefined;
  const dateField = isLitigation ? row.next_hearing_date : row.resolution_date;
  const formattedDate = dateField ? formatDateDisplay(dateField) : "";

  let colorClass = "";

  if (tagsLower === "due") {
    colorClass = "due";
  } else if (tagsLower === "overdue") {
    colorClass = "overdue";
  }

  return (
    <OverlayTrigger
      overlay={<Tooltip>{formattedDate}</Tooltip>}
      rootClose={true}
      placement="bottom"
      delay={{ show: TOOLTIP_DELAY } as any}
    >
      <span
        className={`text-capitalize color-class fw-bold ${colorClass}`}
      >
        {tags.replace(/_/g, " ")}
      </span>
    </OverlayTrigger>
  );
}

export function DateTmpl({ cell }: any) {
  const value = cell.getValue();
  return formatDateDisplay(value);
}

export function LocationTmpl({ cell }: any) {
  const row = cell.getData();
  return (
    <div className="d-flex gap-2">
      {row.location  ? `${row.location.name} - ${row.location.code}`  : "-"}
    </div>
  );
}

export function NameTmpl({ cell }: any) {
  const row = cell.getData();
  const value = row.name || "";
  return (
    <OverlayTrigger
      overlay={<Tooltip>{value}</Tooltip>}
      rootClose={true}
      placement="bottom"
      delay={{ show: TOOLTIP_DELAY } as any}
    >
      <div className="d-flex align-items-center h-100 w-auto">
        <span className="ellipse two-lines">{value}</span>
      </div>
    </OverlayTrigger>
  );
}

// Form Components

export const DropdownIndicator = function (props: any) {
  return (
    <components.DropdownIndicator {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="6"
        viewBox="0 0 10 6"
        fill="none"
      >
        <path
          d="M1 1L5 5L9 1"
          stroke="#1E1E1E"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </components.DropdownIndicator>
  );
};

export const CustomMenuList = (props: any) => {
  const { children, ...rest } = props;
  const childrenArray = React.Children.toArray(children);
  const addNewOption = childrenArray.find((child: any) => child && child.props && child.props.data && child.props.data.value === "add_new");
  const otherOptions = childrenArray.filter((child: any) => !(child && child.props && child.props.data && child.props.data.value === "add_new"));

  return (
    <>
      <components.MenuList {...rest} style={{ maxHeight: "200px", overflowY: "auto" }}>
        {otherOptions}
      </components.MenuList>
      {addNewOption && (
        <div style={{ borderTop: "1px solid #e0e0e0", backgroundColor: "white" }}>
          {addNewOption}
        </div>
      )}
    </>
  );
};
